// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c4W1","question":"styles_question__cfBih","description":"styles_description__kMcoe"};